import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Headers } from '@angular/http';

import { MainService } from 'app/resources/services/index';
import 'bootbox';
import { DefineBootboxId } from 'app/resources/classes';

@Component({

  selector: 'app-confirmacao-novo-pagamento',
  templateUrl: './confirmacao-novo-pagamento.component.html'
})
export class ConfirmacaoNovoPagamentoComponent implements OnInit {

  private readonly TEXTO_INICIAL_DESCRICAO = 'Descrição do pagamento'
  public processando: boolean;
  public bootboxAlertComId: DefineBootboxId = new DefineBootboxId();
  public totalMoeda: string;
  public isValorDocumentoZero: any;
  public ep: string;
  public inputDescricao: string;
  public documentoBeneficiarioTipo: string;

  constructor(public mainService: MainService, public router: Router) { }

  // Tela desabilitada.

  ngOnInit() {
    window.scrollTo(0, 0);
    this.isValorDocumentoZero = undefined;
    this.mainService.pagamentoService.pagamento.valorDescontoMoeda = 0;
    this.ep = '';
    this.inputDescricao = this.TEXTO_INICIAL_DESCRICAO;
    this.documentoBeneficiarioTipo = 'CNPJ';

    if (this.mainService.pagamentoService.pagamento.valorMoeda) {
      this.totalMoeda = new Number(this.mainService.pagamentoService.pagamento.valorMoeda).toFixed(2);
      this.mainService.pagamentoService.pagamento.valorMoeda =
        new Number(this.mainService.pagamentoService.pagamento.valorMoeda).toFixed(2);
      this.mainService.pagamentoService.pagamento.valorDocumentoMoeda =
        this.mainService.pagamentoService.pagamento.valorMoeda;
    }

    if (this.mainService.pagamentoService.pagamento.valorDescontoMoeda) {
      this.mainService.pagamentoService.pagamento.valorDescontoMoeda =
        new Number(this.mainService.pagamentoService.pagamento.valorDescontoMoeda).toFixed(2);
    }
    this.isValorDocumentoZero = this.mainService.pagamentoService.pagamento.valorDocumentoMoeda === 0;
    this.calculaTotais();
  }

  public calculaTotalMoeda() {
    this.totalMoeda = this.mainService.pagamentoService.pagamento.valorDescontoMoeda ?
      new Number(parseFloat(this.mainService.pagamentoService.pagamento.valorMoeda) -
        parseFloat(this.mainService.pagamentoService.pagamento.valorDescontoMoeda)).toFixed(2)
      : this.mainService.pagamentoService.pagamento.valorMoeda;
  };

  public calculaTotalPontos() {
    this.mainService.pagamentoService.pagamento.valorPontos =
      this.mainService.servicesService.moedaToPontos(parseFloat(this.totalMoeda),
        this.mainService.pagamentoService.indiceConversaoMoeda);
  };

  public calculaTotais() {
    this.calculaTotalMoeda();
    this.calculaTotalPontos();
  }

  public clearTextoInicialDescricao() {
    if (this.inputDescricao === this.TEXTO_INICIAL_DESCRICAO) {
      this.inputDescricao = '';
    }
  }

  public save() {
    this.clearTextoInicialDescricao();
    if (!this.inputDescricao) {
      return this.bootboxAlertComId.alerta('Preencha o campo descrição!');
    }
    this.mainService.pagamentoService.pagamento = { ...this.mainService.pagamentoService.pagamento, observacao: this.inputDescricao }
    this.processando = true;
    const cabecalho: Headers = new Headers();
    this.calculaTotais();
    cabecalho.append('Authorization', 'Basic ' + this.mainService.sessionService.getAuthBasic());
    cabecalho.append('X-Auth-Ep', this.ep);
    this.mainService.http.pathRest()
      .post('cartao/pagamento/', this.mainService.pagamentoService.pagamento, true, cabecalho)
      .subscribe(
        sucesso => {
          this.mainService.saldoService.initialize();
          this.mainService.pagamentoService.pagamento = {};
          this.processando = false;
          this.router.navigate(['/pagamentos']);
          this.bootboxAlertComId.alerta('O pagamento foi realizado com sucesso!');
        }, erro => {
          this.processando = false;
          this.bootboxAlertComId.alerta(erro.text());
        });
  }
}



// WEBPACK FOOTER //
// ./src/app/pagamento/confirmacao-novo-pagamento/confirmacao-novo-pagamento.component.ts